import { createValidator, stringLength, stringTrim } from 'app/validators/base'

const validate = stringLength({ min: 1, max: 200 }, stringTrim)

export default createValidator(validate, 'proQuote')
